export default __webpack_public_path__ + "static/media/empty-project.e4f1d2fb.svg";